export default [{
    path: 'userGroup',
    component: () => import('@/views/organization/userGroup/userGroup'),
}]